import {useTranslation} from "react-i18next";
import {Table} from "react-bootstrap";
import DateDisplay from "components/datetime/DateDisplay";

import SenderInfo from "./SenderInfo";
import SenderInfoParams from "./SenderInfoParams";
import useCustomTranslation from "core/customTranslation";
import translations from "./translations";
import Queue from "components/queues/Queue";
import OrderByHeaders from "components/ordering/OrderByHeaders";

const TableConfig = ({items, itemsShow, buttonsTB, setButtonsTB, checkAll, setCheckAll, orderingRef}) => {
    const {t: _tc} = useTranslation("choices");
    const {t: _TC} = useCustomTranslation(translations);

    const onClick = (e) => {
        let checkbox;
        if (e.target.type === "checkbox") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;
        }

        if (checkbox.checked) {
            items.current.addToChosen(e.currentTarget.dataset.idx);
            items.current.items.push(itemsShow.find((item) => item.uuid === e.currentTarget.dataset.idx));
        } else {
            items.current.removeFromChosen(e.currentTarget.dataset.idx);
            items.current.items = items.current.items.filter((item) => item.uuid !== e.currentTarget.dataset.idx);
        }
        items.current.updatePrev();
        handleButtons();
    };

    const handleCheckAll = (e) => {
        let checkboxList = document.querySelectorAll('input[type="checkbox"]');
        if (e.target.checked) {
            setCheckAll(true);
            items.current.items = [...itemsShow];
            items.current.chosen = itemsShow.map((item) => item.uuid);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = true;
            });
        } else {
            setCheckAll(false);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            items.current.items = [];
            items.current.clearChosen();
        }
        handleButtons();
    };

    const handleButtons = () => {
        let buttons = {...buttonsTB};
        const disabled = items.current.items.length === 0;
        buttons.edit.disabled = disabled;
        buttons.send.disabled = disabled;
        buttons.command.disabled = disabled;
        setButtonsTB(buttons);
    };

    const get_senders = (it) => {
        let words = [];
        it.server_carry && words.push(_TC("label.network"));
        it.mqtt_carry && words.push("MQTT");
        it.ntp_carry && words.push("NTP");
        it.gps_carry && words.push("GPS");

        return words.join(", ");
    };

    return (
        <Table striped hover responsive>
            <thead>
                <tr>
                    <th key="-1" style={{width: "32px", verticalAlign: "bottom"}}>
                        <input
                            className="form-check-input"
                            type="checkbox"
                            value="all"
                            checked={checkAll}
                            onChange={handleCheckAll}
                        />
                    </th>
                    <OrderByHeaders orderingRef={orderingRef} />
                </tr>
            </thead>

            <tbody id="data-list">
                {itemsShow.map((item) => (
                    <tr key={item.uuid} data-idx={item.uuid} data-mode={item.mode} onChange={onClick}>
                        <td>
                            <input
                                type="checkbox"
                                name="checkboxContainer"
                                key={item.uuid}
                                data-idx={item.uuid}
                                data-mode={item.mode}
                                defaultChecked={items.current.chosen.includes(item.uuid)}
                                readOnly={true}
                            />
                        </td>
                        <td>
                            {item.uuid}
                            <br />
                            {item.model}
                        </td>
                        <td>
                            {item.config_name} <br />
                            {get_senders(item)}
                        </td>
                        <td>
                            <SenderInfo to="Red" name={item.server_name} attr="server" _TC={_TC} item={item} />
                            <SenderInfo to="MQTT" name={item.mqtt_names} attr="mqtt" _TC={_TC} item={item} />
                            <SenderInfo to="NTP" name={item.ntp_name} attr="ntp" _TC={_TC} item={item} />
                            <SenderInfo to="GPS" name={item.gps_name} attr="gps" _TC={_TC} item={item} />
                        </td>
                        <td>
                            <SenderInfoParams to="" name={_TC("label.battery")} attr="battery" _TC={_TC} item={item} />
                            <SenderInfoParams to="" name={_TC("label.hibernate")} attr="hibernate" _TC={_TC} item={item} />
                            <SenderInfoParams to="" name={_TC("label.reset_default")} attr="default" _TC={_TC} item={item} />
                            <SenderInfoParams to="" name={_TC("label.infoCD")} attr="cd" _TC={_TC} item={item} />
                            <SenderInfoParams to="" name={_TC("label.infoCE")} attr="ce" _TC={_TC} item={item} />
                            <SenderInfoParams to="" name={_TC("label.presets_dd")} attr="dd" _TC={_TC} item={item} />
                        </td>
                        <td>
                            <DateDisplay date={item.updated_at} format="DD-MM-YYYY HH:mm" title={true} />
                        </td>
                        <td>{_tc("shippingState." + item.state)}</td>
                        <td style={{paddingLeft: "15px"}}>
                            <Queue item={item.queue} />
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};

export default TableConfig;
